import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=6d8e12af&scoped=true&"
import script from "./ServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfo.vue?vue&type=style&index=0&id=6d8e12af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e12af",
  null
  
)

export default component.exports